import { Component, EventEmitter, Input, Output } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { ButtonModule } from "primeng/button";
import { DialogModule } from "primeng/dialog";
import { DropdownModule } from "primeng/dropdown";
import { InputTextareaModule } from "primeng/inputtextarea";

import { VERSION } from "@core/version";
import { LocalStorage } from "@shared/enums";

@Component({
  selector: "app-feedback-overlay",
  standalone: true,
  imports: [DialogModule, DropdownModule, ButtonModule, FormsModule, InputTextareaModule],
  templateUrl: "./feedback-overlay.component.html",
  styleUrl: "./feedback-overlay.component.scss",
})
export class FeedbackOverlayComponent {
  @Input() visible: boolean = false;
  @Output() visibleChange = new EventEmitter<boolean>();

  feedbackOptions: any[] = [
    { label: "General", value: "General" },
    { label: "Bug", value: "Bug" },
    { label: "Feature Request", value: "Feature Request" },
  ];
  selectedFeedback: { label: string; value: string } | null = null;
  userFeedback: string | null = null;

  closeDialog() {
    this.selectedFeedback = null;
    this.userFeedback = null;
    this.visible = false;
    this.visibleChange.emit(this.visible);
  }

  onSubmit() {
    const email = "Sequencehistory-feedback@alliedpilots.org";
    const subject = encodeURIComponent(`Sequence History v${VERSION} - ${this.selectedFeedback?.label}`);
    let body = this.generateBody();
    body = encodeURIComponent(body).replace(/%0A/g, "%0D%0A");
    window.location.href = `mailto:${email}?subject=${subject}&body=${body}`;
    this.closeDialog();
  }

  private generateBody() {
    return `${this.userFeedback}\n\n
    DO NOT DELETE BELOW THIS LINE\n
    ---------------------------------------------------\n
    Sequence History Version: ${VERSION}\n
    Feedback Type: ${this.selectedFeedback?.label}\n\n
    Device Information\n
    Operating System: ${this.getDeviceDetails().operatingSystem}\n
    Browser: ${this.getDeviceDetails().browser}\n
    Device Type: ${this.getDeviceDetails().deviceType}\n\n
    User Information\n
    First Name:  ${this.getProfile().firstName}\n
    Last Name:  ${this.getProfile().lastName}\n
    Base:  ${this.getProfile().base}\n
    Seat:  ${this.getProfile().position}\n
    Equipment: ${this.getProfile().equipment}\n
    Employee Number: ${this.getProfile().employeeNumber}\n
    Seniority:  ${this.getProfile().seniority}`;
  }

  private getProfile(): any {
    const profile = localStorage.getItem(LocalStorage.Profile);
    if (profile) {
      return JSON.parse(profile);
    } else {
      return {
        firstName: "Unavailable",
        lastName: "Unavailable",
        base: "Unavailable",
        position: "Unavailable",
        equipment: "Unavailable",
        employeeNumber: "Unavailable",
        seniority: "Unavailable",
      };
    }
  }

  private getDeviceDetails(): { operatingSystem: string; browser: string; deviceType: string } {
    const userAgent = navigator.userAgent;
    let operatingSystem = "Unknown OS";
    let browser = "Unknown Browser";
    let deviceType = "Unknown Device";

    // Determine operating system
    if (userAgent.indexOf("Win") !== -1) operatingSystem = "Windows";
    else if (userAgent.indexOf("Mac") !== -1) operatingSystem = "MacOS";
    else if (userAgent.indexOf("Linux") !== -1) operatingSystem = "Linux";
    else if (userAgent.indexOf("Android") !== -1) operatingSystem = "Android";
    else if (userAgent.indexOf("like Mac") !== -1) operatingSystem = "iOS";

    // Determine browser
    if (userAgent.indexOf("Chrome") !== -1) browser = "Chrome";
    else if (userAgent.indexOf("Safari") !== -1) browser = "Safari";
    else if (userAgent.indexOf("Firefox") !== -1) browser = "Firefox";
    else if (userAgent.indexOf("Edge") !== -1) browser = "Edge";
    else if (userAgent.indexOf("MSIE") !== -1 || userAgent.indexOf("Trident/") !== -1) browser = "Internet Explorer";

    // Determine device type
    if (/Android/i.test(userAgent)) {
      deviceType = "Android";
    } else if (/iPad|iPhone|iPod/i.test(userAgent)) {
      deviceType = "iOS";
    } else if (/Windows/i.test(userAgent)) {
      deviceType = "Windows";
    } else if (/Macintosh/i.test(userAgent)) {
      deviceType = "Mac";
    }

    return { operatingSystem, browser, deviceType };
  }
}
